import { SvgIconType } from './svg.interface';

const Picture: SvgIconType = ({
  width = 40,
  height = 40,
  className = '',
  color = '#3AA5DC',
  onClick
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    onClick={onClick}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M30 5H10C7.23858 5 5 7.23858 5 10V30C5 32.7614 7.23858 35 10 35H30C32.7614 35 35 32.7614 35 30V10C35 7.23858 32.7614 5 30 5ZM10 0C4.47715 0 0 4.47715 0 10V30C0 35.5228 4.47715 40 10 40H30C35.5228 40 40 35.5228 40 30V10C40 4.47715 35.5228 0 30 0H10Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 12.5C13.6193 12.5 12.5 13.6193 12.5 15C12.5 16.3807 13.6193 17.5 15 17.5C16.3807 17.5 17.5 16.3807 17.5 15C17.5 13.6193 16.3807 12.5 15 12.5ZM7.5 15C7.5 10.8579 10.8579 7.5 15 7.5C19.1421 7.5 22.5 10.8579 22.5 15C22.5 19.1421 19.1421 22.5 15 22.5C10.8579 22.5 7.5 19.1421 7.5 15Z"
      fill={color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M28.7477 17.5C29.6398 17.4981 30.5176 17.6941 31.3238 18.0701C32.1061 18.4349 32.7996 18.959 33.3678 19.6022L39.3012 25.7663C40.2587 26.761 40.2285 28.3436 39.2337 29.3012C38.239 30.2587 36.6564 30.2285 35.6988 29.2337L29.7238 23.0264C29.6922 22.9935 29.6615 22.9598 29.6317 22.9253C29.5048 22.7781 29.3595 22.671 29.2106 22.6016C29.0623 22.5324 28.9088 22.4997 28.7585 22.5C28.6082 22.5003 28.4548 22.5337 28.3066 22.6036C28.1609 22.6723 28.0188 22.7771 27.8942 22.9202L14.4211 39.0998C13.5376 40.1608 11.9612 40.3047 10.9002 39.4211C9.83922 38.5376 9.69534 36.9612 10.5789 35.9002L24.0862 19.6795C24.6609 19.0076 25.3702 18.4602 26.1742 18.0811C26.9787 17.7018 27.8557 17.5019 28.7477 17.5Z"
      fill={color}
    />
  </svg>
);

export default Picture;
